import DateFormat from "../common/dateFormat/DateFormat";

const INITIAL_STATE = {
	aguardando: false,
	filtro: {
		data_inicial: DateFormat.getDataInicioMesAtual(),
		data_final: DateFormat.getDataAtual()
	},
	listaDespesasPagas: [],
	listaContaPagar: [],
	listaReceitaRecebida: [],
	listaContaReceber: []
}

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {

		case 'DASHBOARD_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

		case 'DASHBOARD_SET_FILTRO':
			return {
				...state,
				filtro: action.payload
			};

		case 'DASHBOARD_DESPESA_PAGA_LISTADO':
            return {
                ...state, 
                listaDespesasPagas: action.payload.data
            };
		
		case 'DASHBOARD_CONTA_PAGAR_LISTADO':
			return {
				...state, 
				listaContaPagar: action.payload.data
			};
		
		case 'DASHBOARD_RECEITA_RECEBIDA_LISTADO':
            return {
                ...state, 
                listaReceitaRecebida: action.payload.data
            };
		
		case 'DASHBOARD_CONTA_RECEBER_LISTADO':
			return {
				...state, 
				listaContaReceber: action.payload.data
			};

        default:
            return state;
    }
}
